import { render, staticRenderFns } from "./Procon.vue?vue&type=template&id=252a3ece&scoped=true&"
import script from "./Procon.vue?vue&type=script&lang=js&"
export * from "./Procon.vue?vue&type=script&lang=js&"
import style0 from "./Procon.vue?vue&type=style&index=0&id=252a3ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a3ece",
  null
  
)

export default component.exports